<template>
    <div class="col-lg-6 col-md-12 col-xs-12 px-6 cat-element">
      <div class="cl-card">
        <div class="element-header">
          {{ $t('elements.subtitle') }} {{ learningElementLangth }}
        </div>
        <div class="element" v-for="item in learningElement" :key="item.id">
          <div class="element-completed">
            <div class="icon" :class="{ 'active' : isCorrectAnswerRatio(item.correct_count, item.total_count) }"></div>
          </div>
          <div class="element-container">
            <div class="element-title">{{ item.name }}</div>
            <div class="element-grade">{{ getTranslatedName(gradeMap[item.grade_id]) }} |</div>
            <div class="element-correct-answers">{{ $t('common.answers_rate') }} <span>{{ correctAnswer(item.correct_count, item.total_count) }}%</span></div>
          </div>
          <div class="element-action" v-if="!isParentUser">
            <span @click="goToLearningStore(item.id)">{{ $t('common.learning') }} &gt;</span>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import { CT_PERF_URL } from '@/config';
  import labels from '@/mixins/labels';

  export default {
    name: 'cat-element',

    props: [
      'learningElement',
    ],

    mixins: [
      labels,
    ],

    computed: {
      ...mapGetters({
        gradeMap: 'getGradeMap',
        isParentUser: 'isParentUser',
      }),

      learningElementLangth() {
        return this.learningElement.length;
      },

    },

    methods: {
      correctAnswer(correct, total) {
        return Number(((correct / total) * 100).toFixed(1)) || '-';
      },

      isCorrectAnswerRatio(correct, total) {
        return this.correctAnswer(correct, total) >= 65;
      },

      goToLearningStore(id) {
        const domainLectureUrl = `${CT_PERF_URL}/domain/lecture?learning_element_id=${id}`;

        if (this.$mobile.isClasstingClient()) {
          return this.$mobile.openNewWebView(domainLectureUrl);
        }
        return window.open(`/domain/lecture?learning_element_id=${id}`);
      },
    },

  };
</script>

<style lang="scss" scoped>
  .cat-element {
    .element-header {
      font-size: 16px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.4);
      padding: 14px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }

    .element {
      display: flex;

      .element-completed {
        width: 10%;
        padding: 14px;
        text-align: center;

        .icon {
          height: 8px;
          width: 8px;
          background-color: #bbb;
          border-radius: 50%;
          display: inline-block;
        }

        .active {
          background-color: #00c896;
        }
      }
  
      .element-container {
        width: 70%;
        padding: 14px;

        .element-title {
          font-size: 16px;
          color: #000000;
          padding-bottom: 8px;
          overflow: hidden;
          text-overflow: ellipsis; 
          white-space: nowrap;
        }

        .element-grade {
          font-size: 14px;
          font-weight: 500;
          color: #000000;
          opacity: 0.38;
          display: inline-block;
        }

        .element-correct-answers {
          display: inline-block;
          color: rgba(0, 0, 0, 0.4);
          font-size: 14px;

          span {
            color: #00c896;
          }
        }
      }
  
      .element-action {
        width: 20%;
        padding: 24px 14px 24px 14px;
        font-size: 14px;
        font-weight: 500;
        text-align: right;
        color: rgba(0, 0, 0, 0.4);
        cursor: pointer;
      }
    }

  }
</style>


// WEBPACK FOOTER //
// CatElement.vue?72a75b9b